import React from 'react';
import { Box, Typography } from '@mui/material';

function Footer() {
    return (
      <Box
        component="footer"
        sx={{
          mt: 4,            
          py: 2,            
          bgcolor: 'primary.main',
          color: '#fff',
          textAlign: 'center',
        }}
      >
        <Typography variant="body1">
          If you have any questions, please call: 416-289-5000 ext.58105
        </Typography>
        <Typography variant="body2" sx={{ mt: 0.5 }}>
          © 2025 SETAS-ICET Department. All rights reserved.
        </Typography>
      </Box>
    );
  }
  
export default Footer;